export default "__VITE_ASSET__CAEwQbCa__"